import { LoadingButton } from '@mui/lab'
import { ButtonProps } from '@mui/material/Button/Button'
import { useRef } from 'react'

interface MarketingButtonProps {
  loading?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => Promise<any> | any
}

// onClickは非同期関数を渡せるように独自定義
type OmittedButtonProps = Omit<ButtonProps, 'onClick'>

export const MarketingButton = (props: MarketingButtonProps & OmittedButtonProps) => {
  const { onClick, variant = 'contained', loading, children, ...buttonProps } = props

  const working = useRef(false)

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (working.current) {
      // ボタンの処理が終わっていないのでクリックイベントを無視する
      return
    }

    working.current = true

    await onClick?.(event)

    working.current = false
  }

  return (
    <LoadingButton
      {...buttonProps}
      onClick={loading ? undefined : handleClick}
      sx={[
        // 複数の形式があるsx propをcombineするのに配列形式が最適だが、
        // 型定義上undefined不可かつ、ネストが出来ないためのworkaround
        ...[props.sx ?? false].flat(),
      ]}
      tabIndex={loading ? -1 : undefined}
      aria-disabled={loading}
      loading={loading}
      variant={variant}
    >
      {children}
    </LoadingButton>
  )
}
